export default "__VITE_ASSET__6a2e9fca__"